"use client";

import { c as _c } from "react/compiler-runtime";
import { IconAlertTriangle } from "@tabler/icons-react";
import { Button } from "@/components/ui/button";
interface Props {
  onRetry: () => void;
}
export function CartErrorState(t0) {
  const $ = _c(4);
  const {
    onRetry
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconAlertTriangle className="size-12 text-destructive" data-testid="cart-error-icon" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="space-y-1"><p className="text-lg font-medium text-foreground">We couldn't load your cart</p><p className="text-sm">Check your connection and try again.</p></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onRetry) {
    t3 = <div role="alert" className="flex flex-1 flex-col items-center justify-center gap-4 px-6 text-center text-muted-foreground">{t1}{t2}<Button variant="outline" onClick={onRetry}>Try again</Button></div>;
    $[2] = onRetry;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}